// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "3e628cb4a8b671e30ce2" + ".js";
};